(() => {
  if (customElements.get('product-recommendations')) {
    return;
  }
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
  
      this.container = this.querySelector('[data-container]');
      this.container.classList.add('hidden');

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector(
              '[data-container-products]',
            );
  
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[data-container-products]').innerHTML =
                recommendations.innerHTML;

              this.container.classList.remove('hidden');
              this.initSlider();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };
  
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }

    initSlider() {
      const slider = this.querySelector('[data-slider]');

      if (!slider) {
        return;
      }

      const options = {
        navigation: {
          prevEl: slider.querySelector('.swiper-arrow--prev'),
          nextEl: slider.querySelector('.swiper-arrow--next'),
        },
        slidesPerView: 1,
        spaceBetween: 8,
        loop: true,
        breakpoints: {
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 3,
          },
          600: {
            slidesPerView: 2,
            spaceBetween: 16,
          }
        },
      }

      this.sliderInstance = new Swiper(slider, options);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
})();